var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "lit", "lit/decorators.js", "@lit/context", "./app-context", "i18n/i18n", "./utils"], function (require, exports, lit_1, decorators_js_1, context_1, app_context_1, i18n_1, utils_1) {
    "use strict";
    var _a, _b;
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ChatInputElement = void 0;
    i18n_1 = __importDefault(i18n_1);
    class ChatInputElement extends lit_1.LitElement {
        constructor() {
            super(...arguments);
            this.disabled = false;
            this.isStreaming = false;
            this.forceFocus = false;
            this.handleStopGenerating = () => { };
            this.maxLength = null;
            this.maxRows = 6;
            this._composing = false;
            this.submitText = (text) => {
                this._textarea.value = text;
                this._submit(this._textarea);
            };
        }
        renderAvatar() {
            const key = `chat-input-send`;
            const icons = this.icons;
            return (0, utils_1.renderIcon)(icons, key, { altText: (0, i18n_1.default)('icon') });
        }
        render() {
            var _a;
            return (0, lit_1.html) `
      <div class="user-input">
        <div class="textarea-wrapper">
          <textarea
            name="user-input"
            class="textarea"
            aria-describedby="chat-instructions"
            rows="1"
            placeholder=${(0, i18n_1.default)("ask_anything")}
            ?disabled=${this.disabled || this.isStreaming}
            maxlength=${(_a = this.maxLength) !== null && _a !== void 0 ? _a : ""}
            @keydown=${this._handleKeydown}
            @input=${this._handleInput}
            @compositionstart=${() => (this._composing = true)}
            @compositionend=${() => (this._composing = false)}
          ></textarea>
        </div>
        <div class="icon-wrapper">
          ${this.isStreaming
                ? (0, lit_1.html) `
                <div
                  role="button"
                  tabindex="0"
                  class="spinner-container"
                  @click=${this.handleStopGenerating}
                  @keydown=${(e) => {
                    if (e.key === "Enter" || e.key === "Space") {
                        e.preventDefault();
                        this.handleStopGenerating();
                    }
                }}
                  aria-label="Stop generating"
                >
                  <span class="inner-square" aria-hidden="true"></span>
                  <span class="spinner" aria-hidden="true"></span>
                </div>
              `
                : (0, lit_1.html) `
                <div
                  class="icon stop-icon-button"
                  role="button"
                  tabindex="0"
                  title=${(0, i18n_1.default)("send")}
                  aria-label="Start generating"
                  ?disabled=${this.disabled}
                  @click=${this._handleClick}
                  @keydown=${(e) => {
                    if (e.key === "Enter" || e.key === "Space") {
                        e.preventDefault();
                        this._handleClick();
                    }
                }}
                >
                  ${this.renderAvatar()}
                </div>
              `}
        </div>
      </div>
    `;
        }
        updated(_changedProperties) {
            if (this.isStreaming == false && this.forceFocus == true) {
                if (this._textarea) {
                    this._textarea.focus();
                }
            }
        }
        firstUpdated(_changedProperties) {
            if (this.forceFocus == true) {
                if (this._textarea) {
                    this._textarea.focus();
                }
            }
        }
        get _textarea() {
            return this.renderRoot.querySelector("textarea");
        }
        focusTextArea() {
            this._textarea.focus();
        }
        _handleKeydown(event) {
            event.stopPropagation();
            if (!this._textarea)
                return;
            if (event.key === "Enter" && !event.shiftKey) {
                if (this._composing)
                    return;
                event.preventDefault();
                this._submit(this._textarea);
            }
        }
        _handleInput() {
            if (!this._textarea)
                return;
            this._textarea.style.height = "auto"; // reset first
            if (this._textarea.value) {
                const lineHeight = parseFloat(getComputedStyle(this._textarea).height || "20");
                const maxHeight = this.maxRows * lineHeight;
                const currentRows = this.getCurrentRows(this._textarea);
                const newHeight = this._textarea.scrollHeight;
                if (newHeight > maxHeight) {
                    this._textarea.style.height = maxHeight + "px";
                    this._textarea.style.overflowY = "auto";
                }
                else {
                    this._textarea.style.height = currentRows * lineHeight + "px";
                    this._textarea.style.overflowY = "hidden";
                }
            }
            else {
                // reset for placeholder state
                this._textarea.style.height = "";
                this._textarea.style.overflowY = "hidden";
            }
        }
        getCurrentRows(textarea) {
            const lineHeight = parseInt(window.getComputedStyle(textarea).lineHeight);
            const scrollHeight = textarea.scrollHeight - 26; // subtract padding
            const currentRows = Math.floor(scrollHeight / lineHeight);
            return currentRows;
        }
        _handleClick() {
            if (this.disabled || this.isStreaming || !this._textarea)
                return;
            this._submit(this._textarea);
        }
        _submit(textarea) {
            const text = textarea.value;
            if (!text)
                return;
            this.dispatchEvent(new CustomEvent("userinput", {
                detail: { text },
                bubbles: true,
                composed: true
            }));
            textarea.value = "";
            this._handleInput();
            textarea.focus();
            this.isStreaming = true;
        }
    }
    exports.ChatInputElement = ChatInputElement;
    ChatInputElement.styles = (0, lit_1.css) `
    :host {
      display: block;
      padding:5px;
      --input-color: var(--insight-chat-input-color);
      --input-background: var(--insight-chat-input-background);
      --input-border-radius: var(--insight-chat-input-border-radius);
      --input-border-color: var(--insight-chat-input-border-color);
      --input-border-width: var(--insight-chat-input-border-width);
      --input-border-style: var(--insight-chat-input-border-style);
      --input-boxshadow: var(--insight-chat-input-boxshadow);
      --input-font-family: var(--insight-chat-input-font-family);
      --input-max-width: var(--insight-chat-input-max-width);
      --input-border-focus-color: var(--insight-chat-input-border-focus-color);
      --input-border-focus-width: var(--insight-chat-input-border-focus-width);
      --input-border-focus-style: var(--insight-chat-input-border-focus-style);    
    }

    .user-input {
      display: flex;
      flex-flow: row;
      align-items: center;
      padding: 0px;
      padding-right: 11px;
      transition: border-color 0.2s, box-shadow 0.2s;
      gap: 12px;
      background: var(--input-background);
      border-radius: var(--input-border-radius);
      border-color: var(--input-border-color);
      border-width: var(--input-border-width);
      border-style: var(--input-border-style);
      max-width: var(--input-max-width);
      margin:0 auto;
    }

    .user-input:focus,
    .user-input:focus-within {
      /* if the variable is undefined it will add black box around the focused input*/
      box-shadow: var(--input-boxshadow);
      border-radius: var(--input-border-radius);
      border-color: var(--input-border-focus-color);
      border-width: var(--input-border-focus-width);
      border-style: var(--input-border-focus-style);
      outline: none;
    }

    .textarea {
      flex: 1;
      width: 100%;
      border: none;
      background: transparent;
      resize: none;
      overflow-y: auto;
      font: inherit;
      line-height: 1.4;
      outline: none;
      display: flex;
      align-items: center; /* helps with centering */
      scrollbar-width: thin;
      color: var(--input-color);
      font-family: var(--input-font-family);
      padding: 13px;
    }

    .textarea-wrapper {
      flex: 1;
    }

    .icon-wrapper {
      position: relative;
    }

    .textarea:disabled {
      color: #888;
      cursor: not-allowed;
    }

    .icon {
      width: 1.25rem;
      height: 1.25rem;
      margin-left: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #666;
    }

    .stop-icon-button{
      display: block;
    }

    .mb-icon {
      width: 100%
    }

    .icon[disabled] {
      opacity: 0.4;
      cursor: not-allowed;
    }

    .spinner-container {
      position: relative;
      width: 1.55rem;
      height: 1.55rem;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }

    .spinner {
      position: absolute;
      width: 100%;
      height: 100%;
      border: 2px solid #ccc;
      border-top-color: #555;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }

    .inner-square {
      position: relative;
      width: 0.6rem;
      height: 0.6rem;
      background-color: #444;
      z-index: 1; /* Ensures the square stays above the spinner */
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }
  `;
    __decorate([
        (0, context_1.consume)({ context: app_context_1.applicationContext }),
        __metadata("design:type", typeof (_a = typeof Mindbreeze !== "undefined" && Mindbreeze.Application) === "function" ? _a : Object)
    ], ChatInputElement.prototype, "application", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object)
    ], ChatInputElement.prototype, "icons", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: Boolean }),
        __metadata("design:type", Object)
    ], ChatInputElement.prototype, "disabled", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: Boolean }),
        __metadata("design:type", Object)
    ], ChatInputElement.prototype, "isStreaming", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: Boolean }),
        __metadata("design:type", Object)
    ], ChatInputElement.prototype, "forceFocus", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", Function)
    ], ChatInputElement.prototype, "handleStopGenerating", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: Number }),
        __metadata("design:type", Number)
    ], ChatInputElement.prototype, "maxLength", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: Number }),
        __metadata("design:type", Object)
    ], ChatInputElement.prototype, "maxRows", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", Object)
    ], ChatInputElement.prototype, "_composing", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Object)
    ], ChatInputElement.prototype, "submitText", void 0);
});
